import React, { useState } from "react";
import { Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import XLSX from "xlsx";
import { useSelector } from "react-redux";

import CsvMapperForm from "./CsvMapper";
import { getTranslation } from "../../../utils/helper";

const UploadForm = ({ isFetching, setMatch, doUploadContacts }) => {
  const user = useSelector(state => state.auth.user);
  const template = {};
  const setting = useSelector(state => state.setting.setting) || user?.company;

  const [state, setState] = useState({
    data: [],
  });

  const handleFileChange = e => {
    setState({ ...state, loading: true });
    const file = e.file.originFileObj;
    const reader = new FileReader();
    const extension = file.name.split(".").pop().toLowerCase();
    let type;
    switch (extension) {
      case "csv":
        reader.readAsText(file, "UTF-8");
        type = "string";
        break;
      case "xlsx":
        reader.readAsBinaryString(file);
        type = "binary";
        break;
      case "xls":
        reader.readAsBinaryString(file);
        type = "binary";
        break;
      case "xltx":
        reader.readAsBinaryString(file);
        type = "binary";
        break;
    }
    reader.onload = e => {
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type, raw: true, cellDates: true });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws, { raw: false, defval: "" });
      setState({ ...state, file, data, loading: false });
      setMatch(true);
    };
  };

  const handleComplete = async template => {
    const formData = new FormData();
    formData.append("file", state.file);
    formData.append("name", template["Name"]?.value || "");
    formData.append("phone", template["Phone"]?.value || "");
    formData.append("address", template["Address"]?.value || "");
    formData.append("lat", template["Lat"]?.value || "");
    formData.append("lng", template["Lng"]?.value || "");
    formData.append("startTime", template["Start Time"]?.value || "");
    formData.append("endTime", template["End Time"]?.value || "");
    formData.append("duration", template["Duration"]?.value || "");
    formData.append("types", template["Types"]?.value || "");
    formData.append("load", template["Load"]?.value || "");
    formData.append("notes", template["Notes"]?.value || "");
    formData.append("fields", JSON.stringify(template["Fields"] || {}));
    await doUploadContacts(formData);
  };

  const handleCancel = () => {
    setState({ ...state, data: [] });
    setMatch(false);
  };

  const getTemplate = template => {
    return {
      Name: {
        value: template["Name"],
        require: false,
      },
      Phone: {
        value: template["Phone"],
        require: false,
      },
      Address: {
        value: template["Address"],
        require: true,
      },
      Lat: {
        value: template["Lat"],
        require: false,
      },
      Lng: {
        value: template["Lng"],
        require: false,
      },
      "Start Time": {
        value: template["Start Time"],
        require: false,
      },
      "End Time": {
        value: template["End Time"],
        require: false,
      },
      Duration: {
        value: template["Duration"],
        require: false,
      },
      Notes: {
        value: template["Notes"],
        require: false,
      },
      Types: {
        value: template["Types"],
        require: false,
      },
      Load: {
        value: template["Load"],
        require: false,
      },
    };
  };

  return (
    <div className="UploadForm">
      {state.data && state.data.length === 0 && (
        <div className="UploadOrders">
          <Upload.Dragger
            multiple={false}
            accept=".csv, .xls, .xltx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            customRequest={() => null}
            showUploadList={false}
            onChange={e => handleFileChange(e)}>
            <p className="upload-text">Drag and drop to upload or</p>
            <p className="upload-drag-icon">
              Browse
              <UploadOutlined />
            </p>
            <p className="upload-supported">(csv and xls supported)</p>
          </Upload.Dragger>
          <div className="bottom-text">
            <div className="download-text">
              <div>{getTranslation(setting, "Common", "Download Sample File")}: </div>
              <a target="_blank" href="/files/upload_contacts.csv" rel="noopener noreferrer">
                sample.csv
              </a>
            </div>
          </div>
        </div>
      )}
      {state.data && state.data.length > 0 && (
        <div className="UploadOrdersMapping">
          <CsvMapperForm
            isFetching={isFetching}
            template={getTemplate(template)}
            data={state.data}
            onCancel={handleCancel}
            onComplete={handleComplete}
          />
        </div>
      )}
    </div>
  );
};

export default UploadForm;
